<template lang="pug">
  .container-fluid
    tenokate(v-if="signedOut")
      Signedout

    template(v-if="signedIn")
      .row
        .col-md-3
          Selector(v-bind:views="views" v-bind:accessToken="accessToken" v-on:mounted="updateViews" v-on:signIn="signIn")
        .col-md-9
          Reports(v-bind:views="selectedViews")
    template(v-else)
      Signin(v-on:signIn="signIn")
</template>

<script>
import Signin from '@/components/Signin'
import Selector from '@/components/Selector'
import Reports from '@/components/Reports'
import Signedout from '@/components/Signedout'

export default {
  name: 'home',
  components: {
    Signin,
    Selector,
    Reports,
    Signedout,
  },
  data() {
    return {
      signedOut: false,
      signedIn: false,
      user: {
        name: '',
        email: '',
      },
      accessToken: '',
      views: {
        accounts: [],
        selected: [],
        reports: {},
        loading: false,
      },
      logoutTimer: null,
      reports: [],
    }
  },
  methods: {
    async signIn() {
      try {
        const GoogleUser = await this.$gAuth.signIn()

        // On success do something, refer to https://developers.google.com/api-client-library/javascript/reference/referencedocs#googleusergetid
        const profile = GoogleUser.getBasicProfile()
        this.user.name = profile.getName()
        this.user.email = profile.getEmail()

        const auth = GoogleUser.getAuthResponse()
        this.accessToken = auth.access_token
        // console.log(this.accessToken)

        // console.log('user', GoogleUser)
        // ログイン済みの場合はタイマーがセット済みなので一度キャンセル
        if (this.logoutTimer) {
          clearTimeout(this.logoutTimer)
        }

        this.logoutTimer = setTimeout(() => {
          this.signedIn = false
          this.signedOut = true
          this.accessToken = ''
        }, 3590 * 1000)

        this.setAccessToken()

        // ログイン済みの場合はリセットしてリロード
        if (this.signedIn) {
          this.views.accounts = []
          this.views.selected = []
          this.views.reports = {}
          await this.updateViews()
        } else {
          this.signedIn = true // this.$gAuth.isAuthorized
          this.signedOut = false
        }

        this.$ga.page('/report')
        this.$ga.event('webp-share', 'signin', this.user.email, 1)
      } catch(ex) {
        // console.log(ex)
        this.signedIn = false
        this.signedOut = false
      }
    },
    setAccessToken() {
      if (this.accessToken) {
        window.gapi.client.setToken({
          access_token: this.accessToken,
        })
      }
    },
    async updateViews() {
      this.views.loading = true

      const selected = localStorage.getItem('selectedViews') || ''
      this.views.selected = selected.split(/\s*,\s*/)

      await window.gapi.client.load('analytics', 'v3')
      const accounts = await window.gapi.client.analytics.management.accountSummaries.list({
        'max-results': 1000,
      })

      const reports = {}
      let selectedCount = 0
      this.views.accounts = accounts.result.items.map(account => {
        return {
          name: account.name,
          properties: account.webProperties.map(property => {
            return {
              name: property.name,
              views: property.profiles.map(profile => {
                reports[profile.id] = {
                  id: profile.id,
                  view: profile.name,
                  property: property.name,
                  account: account.name,
                  users: [],
                  loading: true,
                  limit: 5,
                }

                const selected = this.views.selected.includes(profile.id)
                if (selected) selectedCount++

                return {
                  name: profile.name,
                  id: profile.id,
                  selected,
                }
              })
            }
          })
        }
      })

      // 選択済みがなければ最初のビューを選択する
      if (selectedCount == 0) {
        const firstView = this.views.accounts[0].properties[0].views[0]
        firstView.selected = true
        this.views.selected = [firstView.id]
      }

      this.views.reports = reports
      this.views.loading = false
    },
  },
  computed: {
    selectedViews() {
      return this.views.selected.map(id => this.views.reports[id]).filter(v => !!v)
    },
  },
  mounted() {
    this.$ga.page('/')
    window.gapi.load()
    this.setAccessToken()
  },
}
</script>

<i18n>
{
  "ja": {
    "sign-in-with-google": "Googleアカウントでサインイン",
    "signed-in": "サインイン済み"
  },
  "en": {
    "sign-in-with-google": "Sign in with Google Account",
    "signed-in": "Signed in"
  }
}
</i18n>